// 防止多次加载
const loadedScripts = new Set<string>();
export default function loadScript(url: string, style = false) {
  return new Promise<void>((resolve) => {
    if (loadedScripts.has(url)) {
      return resolve();
    }
    loadedScripts.add(url);
    const script = style
      ? (document.createElement('link') as any)
      : (document.createElement('script') as any);
    if (style) {
      script.rel = 'stylesheet';
      script.type = 'text/css';
    } else {
      script.type = 'text/javascript';
    }

    if (script.readyState) {
      // IE
      script.onreadystatechange = function () {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          resolve();
        }
      };
    } else {
      // Others
      script.onload = function () {
        resolve();
      };
    }
    if (style) {
      script.href = url;
    } else {
      script.src = url;
    }
    document.getElementsByTagName('head')[0].appendChild(script);
  });
}
